import type { TasksTranslation } from "./en.tasks";

const tasksUz: TasksTranslation = {
  status: {
    pass: "O‘tdi",
    fail: "Xato",
    blocked: "Bloklangan",
    skipped: "O‘tkazib yuborildi",
    untested: "Tekshirilmagan",
    stale: "Eskirgan",
    staleHint: "Bu natija yozilgandan keyin holat o‘zgargan.",
    summary: "O‘tdi: {{pass}}, xato: {{fail}}, bloklangan: {{blocked}}, o‘tkazilgan: {{skipped}}, tekshirilmagan: {{untested}}",
    nPass: "O‘tdi: {{count}}",
    nFail: "Xato: {{count}}",
    nBlocked: "Bloklangan: {{count}}",
    nSkipped: "O‘tkazilgan: {{count}}",
    nStale: "Eskirgan: {{count}}",
    nUntested: "Tekshirilmagan: {{count}}",
  },
  taskState: {
    draft: "Qoralama",
    ready_for_test: "Sinovga tayyor",
    in_testing: "Sinovda",
    changes_requested: "Tuzatish kerak",
    ready_for_retest: "Qayta sinovga tayyor",
    passed: "O‘tdi",
    closed: "Yopilgan",
  },
  priority: {
    critical: "kritik",
    high: "yuqori",
    medium: "o‘rta",
    low: "past",
  },
  source: {
    claude: "claude",
    manual: "qo‘lda",
  },
  replyKind: {
    fixed: "Tuzatildi",
    wont_fix: "Tuzatilmaydi",
    not_a_bug: "Xato emas",
    comment: "Izoh",
  },
  inbox: {
    title: "Kiruvchilar",
    intro: "Barcha loyihalaringizda sizni kutayotgan vazifalar.",
    toTest: "Sinash uchun",
    toFix: "Tuzatish uchun",
    toTestEmpty: "Sinovni kutayotgan hech narsa yo‘q.",
    toFixEmpty: "Sizdan hech qanday tuzatish so‘ralmagan.",
  },
  tasks: {
    filterPeople: "Odamlar",
    myTurn: "Mening navbatim",
    mine: "Meniki",
    inStateSince: "{{time}} dan beri: {{state}}",
    title: "Vazifalar",
    newTask: "Yangi vazifa",
    search: "Kalit yoki nom bo‘yicha qidirish",
    filterState: "Holat bo‘yicha saralash",
    openOnly: "Ochiq",
    empty: "Hozircha vazifalar yo‘q",
    emptyBody: "Vazifani shu yerda yarating yoki Claude uni CLI orqali yaratsin.",
    noMatch: "Saralashga mos vazifa yo‘q.",
    taskTitle: "Nomi",
    description: "Tavsif",
    developer: "Dasturchi",
    tester: "Tester",
    unassigned: "Tayinlanmagan",
    created: "{{key}} vazifasi yaratildi",
    keyInvalid: "Vazifa kalitidan foydalaning: harflar, chiziqcha va raqam (PAY-482).",
    caseCount: "Holatlar: {{count}}",
    notTested: "Hali sinalmagan",
    roundN: "R{{n}}",
    updated: "Yangilandi: {{time}}",
    task: "Vazifa",
    state: "Holat",
    progress: "Oxirgi raund",
    people: "Ishtirokchilar",
  },
  task: {
    turnYours: "Sizning navbatingiz",
    turn: {
      developer: "Dasturchini kutmoqda",
      tester: "Testerni kutmoqda",
      manager: "Menejer yopishini kutmoqda",
    },
    roundN: "{{n}}-raund",
    markReady: "Sinovga tayyor",
    requestRetest: "Qayta sinovni so‘rash",
    startRound: "Raundni boshlash",
    continueRound: "{{n}}-raundni davom ettirish",
    viewRound: "{{n}}-raundni ochish",
    finishRound: "Raundni yakunlash",
    close: "Vazifani yopish",
    reopen: "Qayta ochish",
    addCase: "Holat qo‘shish",
    progressActive: "{{n}}-raund · {{total}} tadan {{done}} tasi yozildi",
    progressLatest: "{{n}}-raund yakunlandi · {{total}} tadan {{done}} tasi yozildi",
    startedBy: "{{time}} boshlandi, {{name}}",
    finishedAt: "{{time}} yakunlandi",
    noCases: "Hozircha test holatlari yo‘q",
    noCasesBody: "Holatlarni shu yerda qo‘shing yoki Claude ularni CLI orqali yuklasin:",
    liveUpdate: "{{name}} o‘zgartirdi: {{what}}",
    liveUpdateGeneric: "{{name}} vazifaga o‘zgartirish kiritdi",
    someone: "Kimdir",
    dismiss: "Yopish",
    tabCases: "Test holatlari",
    tabRounds: "Raundlar",
    tabActivity: "Faollik",
    tabCode: "Kod",
    retestTitle: "Qayta sinovni so‘rash",
    retestHint: "Tester keyingi raundni boshlaganda bu izohni ko‘radi.",
    retestNote: "Nima o‘zgardi",
    retestPlaceholder: "Masalan: TC-3 va TC-4 tuzatildi, TC-8 xato emas (javobga qarang)",
    retested: "Qayta sinov so‘raldi",
    markedReady: "Sinovga tayyor deb belgilandi",
    closedToast: "Vazifa yopildi",
    reopenedToast: "Vazifa qayta ochildi",
    closeTitle: "{{key}} yopilsinmi?",
    closeBody: "Yopilgan vazifalar ro‘yxatlar va kiruvchilarda ko‘rinmaydi. Keyin qayta ochish mumkin; hech narsa o‘chirilmaydi.",
    assigneeSaved: "Ijrochi yangilandi",
    editTask: "Vazifani tahrirlash",
    taskSaved: "Vazifa saqlandi",
    noDescription: "Tavsif yo‘q.",
    actions: "Vazifa amallari",
  },
  round: {
    startTitle: "{{n}}-raundni boshlash",
    scope: "Nimalarni sinash",
    scopeAll: "Barcha holatlar",
    scopeRetest: "Qayta: xato, o‘zgargan va yangi",
    selected: "{{total}} tadan {{count}} tasi tanlandi",
    selectAll: "Hammasini tanlash",
    selectNone: "Tozalash",
    noneSelected: "Kamida bitta holatni tanlang.",
    version: "Versiya",
    noVersion: "Versiyasiz",
    taskVersions: "Shu vazifaning versiyalari",
    otherVersions: "Boshqa versiyalar",
    build: "Build",
    buildPlaceholder: "masalan, 3.14.0",
    environment: "Muhit",
    envPlaceholder: "masalan, staging",
    start: "Raundni boshlash",
    started: "{{n}}-raund boshlandi",
    finishTitle: "{{n}}-raundni yakunlash",
    finishUntested: "{{count}} ta holat hali tekshirilmagan. Ularning barchasi uchun bitta natija tanlang:",
    finishUntestedAs: "Tekshirilmagan holatlar natijasi",
    finishNote: "Dasturchi uchun xulosa",
    finishOutcomeFail: "Xatolar bor: vazifa dasturchiga “Tuzatish kerak” holatida qaytadi.",
    finishOutcomePass: "Xato yo‘q: vazifa o‘tdi deb belgilanadi.",
    finish: "Raundni yakunlash",
    finished: "{{n}}-raund yakunlandi",
    active: "Davom etmoqda",
    done: "Yakunlangan",
    noRounds: "Hozircha raundlar yo‘q. Vazifa sinovga tayyor bo‘lganda tester raundni boshlaydi.",
    by: "Kim boshladi",
    when: "Qachon",
    results: "Natijalar",
    showMatrix: "{{n}}-raund natijalari",
    hideMatrix: "Natijalarni yashirish",
    actual: "Haqiqiy natija",
    testedBy: "Kim tekshirdi",
    addedLater: "raund davomida qo‘shilgan",
    retestNoteLabel: "Dasturchi izohi",
  },
  cases: {
    key: "Kalit",
    case: "Holat",
    priority: "Muhimlik",
    tags: "Teglar",
    reply: "Dasturchi javobi",
    filterStatus: "Joriy raunddagi natija",
    filterAll: "Hammasi",
    filterFailed: "Xatolar",
    filterStale: "Eskirganlar",
    filterUntested: "Tekshirilmaganlar",
    anyPriority: "Har qanday muhimlik",
    anyTag: "Har qanday teg",
    showArchived: "Arxivdagilarni ko‘rsatish",
    archived: "Arxivda",
    new: "YANGI",
    editOrder: "Tartibni o‘zgartirish",
    saveOrder: "Tartibni saqlash",
    moveUp: "{{key}} ni yuqoriga",
    moveDown: "{{key}} ni pastga",
    orderSaved: "Tartib saqlandi",
    noSection: "Bo‘limsiz",
    noMatch: "Saralashga mos holat yo‘q.",
    finding: "topilma",
    notInRound: "Bu raundga kirmagan",
    roundColumn: "{{n}}-raund natijasi",
    open: "{{key}} ni ochish",
  },
  caseDetail: {
    preconditions: "Oldindan shartlar",
    steps: "Qadamlar",
    expected: "Kutilgan natija",
    actual: "Haqiqiy · {{n}}-raund",
    attachments: "Ilovalar",
    upload: "Fayl biriktirish",
    dropHere: "Biriktirish uchun fayllarni shu yerga tashlang",
    uploading: "Yuklanmoqda…",
    uploaded: "Fayl biriktirildi",
    tooBig: "Fayl hajmi 100 MB dan oshmasligi kerak.",
    noAttachments: "Ilovalar yo‘q.",
    removeAttachment: "{{name}} ni o‘chirish",
    attachmentRemoved: "Ilova o‘chirildi",
    roundTag: "R{{n}}",
    history: "Tarix",
    noHistory: "Hali tekshirilmagan.",
    replies: "Dasturchi javoblari",
    noReplies: "Hozircha javob yo‘q.",
    replyKind: "Javob",
    replyNote: "Izoh",
    replyPlaceholder: "Masalan: APIga tekshiruv qo‘shdim, qayta sinab ko‘ring.",
    sendReply: "Javob yuborish",
    replied: "Javob yuborildi",
    revisions: "Versiyalar",
    revN: "v{{n}}",
    createdRev: "yaratildi",
    changed: "o‘zgardi: {{fields}}",
    noChanges: "mazmunda o‘zgarish yo‘q",
    showDiff: "O‘zgarishlarni ko‘rsatish",
    hideDiff: "O‘zgarishlarni yashirish",
    edit: "Tahrirlash",
    archive: "Arxivlash",
    unarchive: "Tiklash",
    archivedToast: "Holat arxivlandi",
    unarchivedToast: "Holat tiklandi",
    by: "{{name}} · {{time}}",
    fields: {
      title: "nomi",
      preconditions: "oldindan shartlar",
      steps: "qadamlar",
      expected: "kutilgan natija",
      priority: "muhimlik",
      tags: "teglar",
      app: "ilova",
    },
    was: "edi",
    now: "bo‘ldi",
    app: "Ilova",
  },
  caseEditor: {
    stepsHint: "Enter keyingi qadamni qo‘shadi · joylashtirilgan ro‘yxat qadamlarga bo‘linadi",
    newTitle: "Yangi test holati",
    editTitle: "{{key}} ni tahrirlash",
    section: "Bo‘lim",
    sectionHint: "Bog‘liq holatlarni guruhlaydi, masalan “Qaytarishlar”.",
    title: "Nima tekshiriladi",
    titlePlaceholder: "masalan, To‘langan summadan katta qaytarish rad etiladi",
    preconditions: "Oldindan shartlar",
    steps: "Qadamlar",
    step: "{{n}}-qadam",
    addStep: "Qadam qo‘shish",
    removeStep: "{{n}}-qadamni o‘chirish",
    moveStepUp: "{{n}}-qadamni yuqoriga",
    moveStepDown: "{{n}}-qadamni pastga",
    expected: "Kutilgan natija",
    priority: "Muhimlik",
    tags: "Teglar",
    tagsHint: "Vergul bilan, masalan negative, refunds",
    app: "Ilova",
    noApp: "Ilovasiz",
    saved: "Holat saqlandi",
    created: "{{key}} holati qo‘shildi",
    liveNotice: "Raund davom etmoqda — tester bu o‘zgarishni belgilangan holda ko‘radi.",
  },
  runner: {
    back: "Vazifaga qaytish",
    progress: "{{total}} tadan {{done}} tasi yozildi · xato: {{fail}}",
    shortcuts: "J / K — o‘tish · P — o‘tdi · F — xato · B — bloklangan · S — o‘tkazish · N — izoh",
    skip: "O‘tkazish",
    note: "Izoh",
    noteRequired: "Aslida nima bo‘lganini yozing — “xato” va “bloklangan” uchun majburiy.",
    notePlaceholder: "Aslida nima bo‘ldi?",
    paste: "Skrinshotni joylashtiring (⌘V / Ctrl+V) yoki fayllarni tashlang",
    prev: "Oldingi",
    next: "Keyingi",
    staleBanner: "Bu holat tekshirilgandan keyin o‘zgargan — iltimos, qayta sinang.",
    archivedBanner: "Bu holat raund davomida arxivlangan.",
    addedLater: "Raund davomida qo‘shilgan",
    previous: "{{n}}-raund",
    devReply: "Dasturchi · {{kind}}",
    readOnly: "Siz raundni ko‘ryapsiz. Natijalarni faqat testerlar va menejerlar yozadi.",
    roundFinished: "Bu raund yakunlangan. Natijalarni faqat ko‘rish mumkin.",
    addFinding: "Topilma qo‘shish",
    findingTitle: "Yangi topilma",
    findingHint: "Yozilgan holatlardan tashqari muammo. U bu raundga xato sifatida qo‘shiladi.",
    findingTitleLabel: "Nima noto‘g‘ri",
    findingExpected: "Kutilgan",
    findingActual: "Haqiqiy",
    findingAdded: "{{key}} topilmasi qo‘shildi",
    empty: "Bu raundda holatlar yo‘q.",
    attachedTo: "{{key}} ga biriktirildi",
    cases: "Raunddagi holatlar",
    stepDone: "{{n}}-qadam bajarildi",
    clear: "Natijani tozalash",
    allDone: "Barcha holatlarning natijasi bor. Tayyor bo‘lsangiz, raundni yakunlang.",
  },
  activity: {
    empty: "Hozircha faollik yo‘q.",
    kinds: {
      task_created: "vazifani yaratdi",
      gitlab_link_added: "GitLab bog‘lanishini qo‘shdi",
      gitlab_link_confirmed: "GitLab bog‘lanishini tasdiqladi",
      gitlab_link_removed: "GitLab bog‘lanishini olib tashladi",
      task_updated: "vazifani yangiladi",
      task_transition: "vazifa holatini o‘zgartirdi",
      cases_synced: "test holatlarini sinxronladi",
      case_created: "holat qo‘shdi",
      case_updated: "holatni tahrirladi",
      case_archived: "holatni arxivladi",
      case_unarchived: "holatni tikladi",
      cases_reordered: "holatlar tartibini o‘zgartirdi",
      round_started: "raundni boshladi",
      round_finished: "raundni yakunladi",
      round_cases_added: "raundga holatlar qo‘shdi",
      result_recorded: "natija yozdi",
      result_cleared: "natijani tozaladi",
      finding_added: "topilma qo‘shdi",
      reply_added: "xatoga javob berdi",
      attachment_added: "fayl biriktirdi",
      attachment_deleted: "faylni o‘chirdi",
      task_title_changed: "vazifa nomini o‘zgartirdi",
      task_description_changed: "tavsifni tahrirladi",
      task_status_changed: "holatni o‘zgartirdi",
      task_due_changed: "muddatni o‘zgartirdi",
      task_priority_changed: "muhimlikni o‘zgartirdi",
      task_assignee_added: "ijrochi biriktirdi",
      task_assignee_removed: "ijrochini olib tashladi",
      task_tester_changed: "testerni o‘zgartirdi",
      task_parent_changed: "asosiy vazifani o‘zgartirdi",
      task_epic_changed: "epikni o‘zgartirdi",
      task_release_changed: "relizni o‘zgartirdi",
      task_tag_added: "teg qo‘shdi",
      task_tag_removed: "tegni olib tashladi",
      task_attachment_added: "vazifaga fayl biriktirdi",
      task_attachment_removed: "vazifa faylini o‘chirdi",
      task_moved_out: "vazifani boshqa loyihaga ko‘chirdi",
      task_moved_in: "vazifani shu yerga ko‘chirdi",
      task_deleted: "vazifani o‘chirdi",
      task_mark_ready: "sinovga tayyor deb belgiladi",
      task_request_retest: "qayta sinovni so‘radi",
    },
    system: "Mixla",
    counts: {
      created: "qo‘shildi: {{count}}",
      updated: "o‘zgardi: {{count}}",
      archived: "arxivlandi: {{count}}",
    },
  },
  tokens: {
    apiDocs: "API hujjatlari →",
    tryIt: "Sinab ko‘ring:",
    howToUse: "Tokendan qanday foydalanish →",
    revokeBotBody: "Bu tokendan foydalanayotgan hamma narsa darhol ishlamay qoladi.",
    title: "CLI kirish",
    intro: "Shaxsiy tokenlar mixla CLI ga — u orqali Claudega ham — sizning nomingizdan ishlash imkonini beradi. Ularni parol kabi saqlang.",
    name: "Nomi",
    namePlaceholder: "masalan, MacBook · Claude Code",
    expiry: "Amal qilish muddati",
    days: "{{count}} kun",
    create: "Token yaratish",
    createdTitle: "Yangi tokeningiz",
    createdWarning: "Hozir nusxalab oling. U boshqa ko‘rsatilmaydi.",
    command: "CLI ga quyidagi buyruq bilan kiring:",
    lastUsed: "Oxirgi foydalanish",
    created: "Yaratilgan",
    expires: "Tugaydi",
    revoke: "Bekor qilish",
    revokeTitle: "“{{name}}” bekor qilinsinmi?",
    revokeBody: "Bu tokendan foydalanayotgan CLI darhol ishlashdan to‘xtaydi.",
    revoked: "Token bekor qilindi",
    empty: "Hozircha tokenlar yo‘q.",
    done: "Tayyor",
  },
  cliGuide: {
    title: "CLI + Claude Code sozlash",
    time: "taxminan 5 daqiqa, har bir kompyuterda bir marta",
    os: "Tizimingiz",
    install: {
      title: "mixla CLI ni o‘rnating",
      body: "macOS va Linux da ishlaydi. ~/.local/bin ga o‘rnatiladi va u PATH da bo‘lmasa, aytib beradi. Yangilash uchun qayta ishga tushiring.",
      bodyWindows: "PowerShell ga qo‘ying. mixla.exe ni foydalanuvchingiz uchun o‘rnatadi (administrator huquqisiz) va PATH ga qo‘shadi. Yangilash uchun qayta ishga tushiring.",
    },
    token: {
      title: "Shaxsiy token yarating",
      body: "Quyidagi shakldan foydalaning. Kompyuter nomi bilan atang, masalan “MacBook · Claude Code”. Token faqat bir marta, tayyor kirish buyrug‘i bilan birga ko‘rsatiladi.",
      action: "Token shakliga o‘tish",
    },
    login: {
      title: "CLI ga kiring",
      body: "Token oynasidagi kirish buyrug‘ini qo‘ying (unda shu server va tokeningiz bor). So‘ng kimligingizni tekshiring.",
    },
    skill: {
      title: "Claude ga Mixla bilan ishlashni o‘rgating",
      body: "Claude Code Mixla jarayonini (holatlarni yuklash, nosozliklarni tuzatish, xatolar) ko‘nikma (skill) deb ataladigan qisqa yo‘riqnoma faylidan o‘rganadi. Uni qayerga o‘rnatishni tanlang:",
      scope: "Ko‘nikmani qayerga o‘rnatish",
      global: "Barcha repozitoriyalarimga",
      globalTag: "tavsiya etiladi",
      globalHint: "Uy papkangizda saqlanadi (~/.claude/skills/mixla). Shu kompyuterdagi har qanday repozitoriyada ishlaydi; hech narsani commit qilish shart emas.",
      repo: "Faqat bitta repozitoriyaga",
      repoHint: "Repozitoriya ichida saqlanadi (.claude/skills/mixla). Uni commit qiling — Claude Code ishlatadigan hamkasblaringizda ham bo‘ladi.",
      repoCd: "cd repozitoriyangiz/yo‘li",
      copy: "Ko‘nikmani nusxalash",
      copyHint: "CLI yo‘qmi? Ko‘nikmani nusxalab, quyidagi fayl sifatida saqlang:",
    },
    link: {
      title: "Repozitoriyani Mixla loyihasiga bog‘lang (ixtiyoriy)",
      body: "Vazifa buyruqlari loyihani vazifa kalitidan biladi (PAY-482 → PAY). Xato buyruqlari uchun loyihani repozitoriyaga bir marta yozib qo‘ying — shunda na siz, na Claude --project ko‘rsatmaysiz:",
      project: "Loyiha",
    },
    use: {
      todo: "Mixla’da meni nima kutyapti?",
      title: "Claude dan so‘rang",
      body: "Shu repozitoriyada Claude Code ni oching va oddiy so‘zlar bilan so‘rang, masalan:",
      push: "PAY-482 uchun test holatlarini yukla",
      fix: "Testerlar PAY-482 da topgan xatolarni tuzat",
      bug: "BUG-12 ni ko‘rib chiq va asl sababini top",
    },
    trouble: "Ishlamayaptimi? “mixla whoami” CLI ga kirilganini ko‘rsatadi. Bekor qilingan yoki muddati o‘tgan token uchun yangisini yarating va qayta kiring. Sozlamalar ~/.config/mixla/config.json da.",
  },
};

export default tasksUz;
